import Toast from './index.vue'
export default {
    install(Vue,opt) {
        const toastMark = Vue.extend(Toast)
        this.domLoadList=[]
        this.cashMsg=''
        var _this=this
        function $toast(param) {
            let toast = new toastMark()
            //toast文案
            toast.msg=param.msg
            toast.time=param.time || 1500
            toast.$mount()
            //msg信息相同不在append
            if(toast.msg==_this.cashMsg){
                return
            }
            //缓存dom
            _this.domLoadList.push(toast.$el)
            //插入dom元素
            document.querySelector(opt.container).appendChild(toast.$el)
            _this.cashMsg=toast.msg
            toast.$el.timer=setTimeout(()=>{
                if(_this.domLoadList[0]){
                    document.querySelector(opt.container).removeChild(_this.domLoadList[0])
                    _this.domLoadList.splice(0,1)
                    _this.cashMsg=''
                }
            },toast.time)
        }
        $toast.end=function(p){
            // console.log(this,'end');
            // if(_this.domLoadList[0]){
            //     document.querySelector(opt.container).removeChild(_this.domLoadList[0])
            //     _this.domLoadList.splice(0,1)
            // }
        }
        Vue.toast = Vue.prototype.$toast = $toast
    }
}



// WEBPACK FOOTER //
// ./src/components/v_toast/index.js